import Image from "next/image"
import styles from "./tnspcunit8.module.css";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
const TNPSC_Unit_8_Enrichment_Test_Batch= () => {
   
    return (
        <>
        <Navbar title="tnpsc" />

        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-5">
                <h1 className={`${styles.pagemaintitle}`}>TNPSC UNIT 8 Enrichment Test Series</h1>
            </div>
            </div>

        </div>


       {/* table */}
       <div className="container">
    <div className="row pt-3 prelimstable">
        <div className="col">
          <div className={`${styles.tablescroll}`}>
                 <table class="table">
                     <thead class="table" style={{backgroundColor:"#818C98"}}>
                        <tr>
                            <td className={`${styles.tableheading}`}>Center<br/></td>
                            <td className={`${styles.tableheading}`}>Regular(Shedule)<br/></td>
                            <td className={`${styles.tableheading}`}>Weekend (Schedule)<br/></td>
                            <td className={`${styles.tableheading}`}>Fee<br/></td>
                            <td className={`${styles.tableheading}`}>Payment<br/></td>
                        </tr>
                 </thead>
                 <tbody>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Online<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/Unit-8-Enrichment-Test-Series-Regular-Online-Batch.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/Unit-8-Enrichment-Test-Series-Weekend-Online.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/annanagar/Unit-8-Enrichment-Test-Series-Regular-Offline-Batch.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/annanagar/Unit-8-Enrichment-Test-Series-Week-End-OFFLINE-BATCH.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Adyar<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/adyar/tnpsc-Unit-8-Enrichment-Test-Series-Adyar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            {/* <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/annanagar/Unit-8-Enrichment-Test-Series-Week-End-OFFLINE-BATCH.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                            <td className={`${styles.tablepara}`}>--- </td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Salem<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/salem/TNPSC-Unit-8-Enrichment-Test-Series-Salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/salem/TNPSC-Unit-8-Enrichment-Test-Series-Week-End-SALEM.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Madurai<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/madurai/TNPSC-Unit-8-Enrichment-Test-Series-Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/madurai/</td>TNPSC-Unit-8-Enrichment-Test-Series-Week-End-Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Trichy<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/tirchy/TNPSC-Unit-8-Enrichment-Test-Series-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/tirchy/TNPSC-Unit-8-Enrichment-Test-Series-Week-End-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Thiruvarur<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/Thiruvarur/TNPSC-Unit-8-Enrichment-Test-Series-Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>--- </td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Namakkal<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/Namakkal/TNPSC-Unit-8-Enrichment-Test-Series-Namakkal.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>--- </td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Coimbatore<br/></td>
                            <td><Link href="/pdf/TNPSC_Unit_8_Enrichment_Test_Batch/Coimbatore/TNPSC-Unit-8-Enrichment-Test-Series-Coimbatore.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td className={`${styles.tablepara}`}>--- </td>
                            <td className={`${styles.tablepara}`}>750 </td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        
                        
                        
                       
                    </tbody>
              </table>
        </div>
        </div>
    </div>
</div>
 {/* <!-- Features of Test series: --> */}
 <div className="container-fluid mt-5" style={{backgroundColor:"#F4F6F8"}}>
        <div className="row">
          <div className="col py-5 my-md-3">
            <div className="container">
              <div className="row">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0`}>
                  Features of Test series:
                  </h2>
                </div>
              </div>

              <div className="row">
                <div className="col px-0">
                  <p className={`${styles.aboutparagraph1} pt-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Question paper and Explanation will be provided only in Tamil.</span></p>
                  <p className={`${styles.aboutparagraph1} `}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>After every test, there will be complete discussion of the questions paper by expert team through live streaming</span></p>
                  <p className={`${styles.aboutparagraph1} `}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Test series is a real simulation of TNPSC exams</span></p>
                  <p className={`${styles.aboutparagraph1} `}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>This test series covers the Unit 8 syllabus holistically</span></p>
                  <p className={`${styles.aboutparagraph1} `}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>Flexible for working candidate to take the test as per their availability</span></p> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <Interest />
    <Footer />

        </>
    )
}

export default TNPSC_Unit_8_Enrichment_Test_Batch
